import { render, staticRenderFns } from "./ViewerCharsets.vue?vue&type=template&id=2f51653d&scoped=true"
import script from "./ViewerCharsets.vue?vue&type=script&lang=js"
export * from "./ViewerCharsets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f51653d",
  null
  
)

export default component.exports